/**
 * @generated SignedSource<<6132f69e0aa12399cbc0776c8ae83a83>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DamSceneAssetType = "ASSET_TYPE_GIF" | "ASSET_TYPE_IMAGE" | "ASSET_TYPE_JSON" | "ASSET_TYPE_MATERIAL" | "ASSET_TYPE_MESH" | "ASSET_TYPE_MP4" | "ASSET_TYPE_UNSPECIFIED";
export type DamSceneRole = "SCENE_ASSET_ROLE_CONFIG" | "SCENE_ASSET_ROLE_MATERIAL" | "SCENE_ASSET_ROLE_MODEL" | "SCENE_ASSET_ROLE_THUMBNAIL" | "SCENE_ASSET_ROLE_UNSPECIFIED";
import { FragmentRefs } from "relay-runtime";
export type damDialog_fragment$data = {
  readonly damScenes: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly assets: ReadonlyArray<{
          readonly asset: {
            readonly assetType: DamSceneAssetType;
            readonly file: {
              readonly fileUrl: string;
            } | null;
            readonly thumbnailUrl: string;
            readonly title: string | null;
          };
          readonly roles: ReadonlyArray<DamSceneRole>;
        }>;
        readonly id: string;
        readonly title: string;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "damDialog_fragment";
};
export type damDialog_fragment$key = {
  readonly " $data"?: damDialog_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"damDialog_fragment">;
};

import damDialogPaginationQuery_graphql from './damDialogPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "damScenes"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": "0",
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "filterMasks"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "sortBy"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "title"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": damDialogPaginationQuery_graphql
    }
  },
  "name": "damDialog_fragment",
  "selections": [
    {
      "alias": "damScenes",
      "args": [
        {
          "kind": "Variable",
          "name": "filterMasks",
          "variableName": "filterMasks"
        },
        {
          "kind": "Variable",
          "name": "sortBy",
          "variableName": "sortBy"
        },
        {
          "kind": "Variable",
          "name": "title",
          "variableName": "title"
        }
      ],
      "concreteType": "DamScenesConnection",
      "kind": "LinkedField",
      "name": "__damDialog_damScenes_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DamScenesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "DamScene",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DamScenesAssets",
                  "kind": "LinkedField",
                  "name": "assets",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "roles",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "DamSceneAsset",
                      "kind": "LinkedField",
                      "name": "asset",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "assetType",
                          "storageKey": null
                        },
                        (v1/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "DamSceneAssetFile",
                          "kind": "LinkedField",
                          "name": "file",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileUrl",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "thumbnailUrl",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "64adde6885b1f91c3fc7eeb5e4ddf1bd";

export default node;
